import { Button } from "@mui/material";
import React from "react";
import { ExcelIcon } from "@dexteel/mesf-core";

interface Props {
	handleExportToExcel: () => void;
	disabled?: boolean;
}

export const ExcelButton = ({ handleExportToExcel, disabled }: Props) => {
	return (
		<Button
			size="medium"
			variant="outlined"
			disabled={disabled}
			onClick={handleExportToExcel}
			startIcon={<ExcelIcon />}
			color="success"
			fullWidth
		>
			EXPORT TO EXCEL
		</Button>
	);
};
